import { actionConstants } from '../actions/actionConstants';

const initState = {
  isFetching: false,
  isSubmitting: false,
  phrases: [],
  getPhraseError: {},
  errors: '',
};

export default (state = initState, action) => {
  switch (action.type) {
    case actionConstants.GETTING_PHRASES:
      return { ...state, isFetching: true, errors: '' };
    case actionConstants.CLEAR_PHRASES:
      return { ...state, phrases: [] };
    case actionConstants.GET_PHRASES_SUCCESS:
      return { ...state, phrases: action.data.items, isFetching: false };
    case actionConstants.GET_PHRASES_FAILURE:
      return { ...state, errors: action.data, isFetching: false };
    case actionConstants.GET_PHRASE_SUCCESS:
      return { ...state, phrase: action.data };
    case actionConstants.GET_PHRASE_FAILURE:
      return { ...state, getPhraseError: action.data };
    case actionConstants.CREATE_PHRASE_SUCCESS:
      return { ...state };
    case actionConstants.CREATE_PHRASE_FAILURE:
      return { ...state, errors: action.data, isSubmitting: false };
    case actionConstants.EDIT_PHRASE_SUCCESS:
      return { ...state, isSubmitting: false };
    case actionConstants.EDIT_PHRASE_FAILURE:
      return { ...state, errors: action.data, isSubmitting: false };
    case actionConstants.DELETE_PHRASE_SUCCESS:
      return { ...state, isFetching: false };
    case actionConstants.DELETE_PHRASE_FAILURE:
      return { ...state, errors: action.data, isFetching: false };
    default:
      return state;
  }
};
